import { Navigate, Outlet } from 'react-router-dom'
import Sidebar from '../components/Sidebar'
import './ProtectedLayout.css'

function ProtectedLayout() {
  const token = localStorage.getItem('techdelivery_token')

  if (!token) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className="protectedLayout">
      <Sidebar />

      <main className="protectedContent">
        <Outlet />
      </main>
    </div>
  )
}

export default ProtectedLayout